<template>
  <div class="container">
    <div class="detail-content" v-show="billDetail">
      <div v-if="billDetail && this.$route.query.status == 0">
        <div class="people">
          <div class="people-label">患者姓名：</div>
          <div class="people-text">{{ billDetail.patientName }}</div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">挂号科室:</div>
          <div class="pay-num-text">{{ billDetail.sectionName }}</div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">医生名称:</div>
          <div class="pay-num-text">{{ billDetail.doctorName }}</div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">就诊日期:</div>
          <div class="pay-num-text">
            {{ billDetail.visitDate }}
          </div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">挂号费：</div>
          <div class="pay-num-texta" v-if="this.$route.query.id">
            ￥{{ billDetail.amount }}
          </div>
          <div class="pay-num-texta" v-else>￥{{ billDetail.RegFee }}</div>
        </div>
        <div class="dl-title" v-show="billDetail.ClinicCode != null">
          就诊码
        </div>
        <div class="dl" v-show="billDetail.ClinicCode != null">
          <svg id="barcode"></svg>
        </div>
      </div>
      <div v-if="billDetail && billDetail.status == 1">
        <div class="people">
          <div class="people-label">患者姓名：</div>
          <div class="people-text">{{ billDetail.Name }}</div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">挂号科室:</div>
          <div class="pay-num-text">{{ billDetail.DeptName }}</div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">医生名称:</div>
          <div class="pay-num-text">{{ billDetail.DoctName }}</div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">就诊日期:</div>
          <div class="pay-num-text">
            {{ billDetail.RegDate.slice(0, 10).replace(/\//g, '-') }}
          </div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">挂号费：</div>
          <div class="pay-num-texta" v-if="this.$route.query.id">
            ￥{{ billDetail.RegFee }}
          </div>
          <div class="pay-num-texta" v-else>￥{{ billDetail.RegFee }}</div>
        </div>
        <div class="pay-num">
          <div class="pay-num-label">缴费凭证：</div>
          <div class="pay-num-text">
            {{ billDetail.InvoiceNo }}
          </div>
        </div>
        <div class="dl-title" v-show="billDetail.ClinicCode != null">
          就诊码
        </div>
        <div class="dl" v-show="billDetail.ClinicCode != null">
          <svg id="barcode"></svg>
        </div>
        <div class="ptrigger">
          <div class="ptrigger-dl-title">
            电子票据凭证
          </div>
          <div class="de" v-if="billDetail.BillInfo">
            <a href="javascript:void(0);" @click="getPTrigger">
              {{ billDetail.BillInfo.Billno }} >></a
            >
          </div>
          <div class="invoice" v-else>
            <a href="javascript:void(0);" @click="getPTrigger">开具发票 >></a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="detail-footer"
      v-if="billDetail && this.$route.query.status == 0"
    >
      <div class="detail-footer-left">
        合计 <span class="much"> {{ billDetail.amount }} 元</span>
      </div>
      <div class="detail-footer-right">
        <van-button
          round
          size="small"
          v-if="billDetail.payType == 3 || billDetail.payType == 3"
          >已占号</van-button
        >
        <van-button round type="info" size="small" @click="toGoPay" v-else
          >缴费</van-button
        >
      </div>
    </div>
    <div class="detail-footer" v-if="billDetail && billDetail.status == 1">
      <div>
        <div class="detail-footer-left">
          合计 <span class="much"> {{ billDetail.RegFee }} 元</span>
          <a href="javascript:void(0);" class="refund" @click="toRefund"
            >退款</a
          >
        </div>
        <!--<div class="detail-footer-right">
           <van-button
          round
          type="info"
          size="small"
          @click="toRefund"
          v-if="state()"
          >退款</van-button
        >
        <span v-else>
          <span v-if="billDetail.state == 'N'"
            >如未就诊，退款请至人工窗口</span
          ></span
        > 
        </div>-->
      </div>
    </div>
    <van-dialog id="van-dialog" />
  </div>
</template>

<script>
import {
  findOrderInfoByPatient,
  refund,
  refundorder,
  getGHPTrigger,
  getPayOrderList
} from '@/api/api'
import { Dialog, Toast } from 'vant'
import jsbarcode from 'jsbarcode'
export default {
  data() {
    return {
      billDetail: {
        BeginTime: '',
        EndTime: ''
      },
      ghInfoStr: '',
      patientId: '',
      ClinicCode: '',
      jump: false
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.id) {
      this.getData()
    } else {
      if (localStorage.getItem('patientId')) {
        this.patientId = localStorage.getItem('patientId')
        this.ClinicCode = localStorage.getItem('ClinicCode')
        this.getPayOrderList()
        return
      }
      this.billDetail = this.$route.params
      localStorage.setItem('patientId', this.$route.params.patientId)
      localStorage.setItem('ClinicCode', this.billDetail.ClinicCode)
      this.ghInfoStr = JSON.stringify(this.billDetail)
      if (this.billDetail.BillInfo) {
        this.jump = true
      }

      if (this.billDetail.ClinicCode != null) {
        this.$nextTick(() => {
          jsbarcode('#barcode', this.billDetail.ClinicCode, {
            displayValue: true
          })
        })
      }
    }
  },
  beforeDestroy() {
    localStorage.removeItem('patientId')
    localStorage.removeItem('ClinicCode')
  },
  methods: {
    getPayOrderList() {
      getPayOrderList({ patientId: this.patientId })
        .then(res => {
          if (res.code === 200) {
            let payList = JSON.parse(res.msg).body
            this.billDetail = payList.filter(item => {
              return item.ClinicCode === this.ClinicCode
            })[0]
            this.billDetail.status = 1
            if (this.billDetail.ClinicCode != null) {
              this.$nextTick(() => {
                jsbarcode('#barcode', this.billDetail.ClinicCode, {
                  displayValue: true
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
          Toast.fail({
            message: '数据获取失败',
            forbidClick: true
          })
        })
    },
    state() {
      if (this.billDetail.state == 'Y') return false
      if (this.billDetail.flag < 0) return true
      return false
    },
    getData() {
      let data = {
        patientId: this.$route.query.patientId,
        status: this.$route.query.status + ''
      }
      findOrderInfoByPatient(data)
        .then(res => {
          this.billDetail = res.data.filter(item => {
            if (this.$route.query.id == item.id) {
              return item
            }
          })
          this.billDetail = this.billDetail[0]
        })
        .catch(err => {
          console.log(err)
          Toast.fail({
            message: '数据获取失败',
            forbidClick: true
          })
        })
    },
    toGoPay() {
      this.$router.push({
        name: 'goPay',
        params: this.billDetail
      })
    },
    toRefund() {
      Dialog.confirm({
        title: '取消挂号',
        message: '确认退号后不可撤销，是否确定退号'
      })
        .then(() => {
          // on confirm
          let query = {
            orderNo: this.billDetail.OrderId,
            ghInfoStr: this.ghInfoStr
          }
          refundorder(query).then(res => {
            if (res.code == 200) {
              Dialog.alert({
                message: '退号成功,钱款会在24小时内退回原账户'
              }).then(() => {
                // on close
                window.location.replace(
                  window.location.protocol +
                    '//' +
                    window.location.host +
                    '/#/payList'
                )
              })
            } else {
              Dialog.alert({
                message: res.msg
              }).then(() => {})
            }
          })
        })
        .catch(err => {})
    },
    returnAmount(am) {
      return Number(am) / 100
    },

    // 开票
    getPTrigger() {
      getGHPTrigger({ ghInfoStr: this.ghInfoStr })
        .then(res => {
          if (this.jump) {
            window.location.href = res.data.data.pictureNetUrl
          } else {
            Dialog.confirm({
              title: '提示',
              message: '是否跳转页面'
            })
              .then(() => {
                // on confirm
                window.location.href = res.data.data.pictureNetUrl
              })
              .catch(() => {
                // on cancel
              })
          }
        })
        .catch(err => {
          console.log(err)
          Toast.fail({
            message: '数据获取失败',
            forbidClick: true
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.ptrigger {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  padding: 0 35px;
  align-items: center;
  font-size: 18px;
  height: 24px;
  line-height: 24px;
}

.dl-title {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  font-size: 18px;
  background: #fff;
}

.dl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #fff;
}

.de {
  text-align: center;
  background: #fff;
}

.de span {
  color: blue;
}

.container {
  width: 100vw;
  min-height: 100vh;
}

.detail-content {
  width: 100vw;
  min-height: calc(100vh - 85px);
  margin-bottom: 25px;
}

.detail-footer {
  width: 100vw;
  height: 55px;
  background: #fff;
  font-size: 18px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &-left {
    display: flex;
    align-items: center;

    .much {
      color: rgb(237, 125, 84);
      padding-left: 5px;
    }
  }

  &-right {
    display: flex;
    align-items: center;
  }
}

.people {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);

  &-label {
    width: 100px;
    color: #666;
    display: flex;
    align-items: center;
    font-size: 18px;
  }

  &-text {
    /* width: calc(100% - 80px); */
    font-size: 18px;
  }
}

.pay-num {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);
  border-top: 1px solid rgb(234, 234, 234);

  &-label {
    color: #666;
    display: flex;
    align-items: center;
    font-size: 18px;
  }

  &-texta {
    font-size: 18px;
    color: rgb(237, 125, 84);
  }

  &-text {
    font-size: 18px;
  }
}

@font-face {
  font-family: 'iconfont1';
  src: url('data:font/truetype;charset=utf-8;base64,AAEAAAANAIAAAwBQRkZUTYzIet0AAAagAAAAHEdERUYAKQAKAAAGgAAAAB5PUy8yPSBIpAAAAVgAAABWY21hcAAP6l0AAAHAAAABQmdhc3D//wADAAAGeAAAAAhnbHlmW+3WHgAAAxAAAACsaGVhZBq0l8wAAADcAAAANmhoZWEHtgOFAAABFAAAACRobXR4DAAAmQAAAbAAAAAQbG9jYQBWAAAAAAMEAAAACm1heHABEQBBAAABOAAAACBuYW1lKeYRVQAAA7wAAAKIcG9zdOvZ5RkAAAZEAAAANAABAAAAAQAA2WlBQl8PPPUACwQAAAAAANuSKeoAAAAA25Ip6gCZ/7wD2AM/AAAACAACAAAAAAAAAAEAAAOA/4AAXAQAAAAAAAPYAAEAAAAAAAAAAAAAAAAAAAAEAAEAAAAEADUAAwAAAAAAAgAAAAoACgAAAP8AAAAAAAAAAQQAAZAABQAAAokCzAAAAI8CiQLMAAAB6wAyAQgAAAIABQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUGZFZABA5rLmsgOA/4AAXAOAAIAAAAABAAAAAAAABAAAAAAAAAAEAAAABAAAmQAAAAMAAAADAAAAHAABAAAAAAA8AAMAAQAAABwABAAgAAAABAAEAAEAAOay//8AAOay//8ZUQABAAAAAAAAAQYAAAEAAAAAAAAAAQIAAAACAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFYAAAADAJn/vAPYAz8AFwAjADQAAAEuASM+ATcuAScOAQceARcOAQchJjU+ARcOAQceARc+ATcuAQcjIiYnNT4BMhYdATMeARQGAtMtazxSbAMDbFJSbAMDbFKYygQBbwICcKFSbAICbFJRbAICbAhRDRIBARIbEjEOEhIBcyQnAm1RUm0CAm1SUW0CBNqjERJjlB0CbFFRbAICbFFRbOQSDnUOEhIOVQESGxIAAAAAAAASAN4AAQAAAAAAAAAVACwAAQAAAAAAAQAIAFQAAQAAAAAAAgAHAG0AAQAAAAAAAwAIAIcAAQAAAAAABAAIAKIAAQAAAAAABQALAMMAAQAAAAAABgAIAOEAAQAAAAAACgArAUIAAQAAAAAACwATAZYAAwABBAkAAAAqAAAAAwABBAkAAQAQAEIAAwABBAkAAgAOAF0AAwABBAkAAwAQAHUAAwABBAkABAAQAJAAAwABBAkABQAWAKsAAwABBAkABgAQAM8AAwABBAkACgBWAOoAAwABBAkACwAmAW4ACgBDAHIAZQBhAHQAZQBkACAAYgB5ACAAaQBjAG8AbgBmAG8AbgB0AAoAAApDcmVhdGVkIGJ5IGljb25mb250CgAAaQBjAG8AbgBmAG8AbgB0AABpY29uZm9udAAAUgBlAGcAdQBsAGEAcgAAUmVndWxhcgAAaQBjAG8AbgBmAG8AbgB0AABpY29uZm9udAAAaQBjAG8AbgBmAG8AbgB0AABpY29uZm9udAAAVgBlAHIAcwBpAG8AbgAgADEALgAwAABWZXJzaW9uIDEuMAAAaQBjAG8AbgBmAG8AbgB0AABpY29uZm9udAAARwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABzAHYAZwAyAHQAdABmACAAZgByAG8AbQAgAEYAbwBuAHQAZQBsAGwAbwAgAHAAcgBvAGoAZQBjAHQALgAAR2VuZXJhdGVkIGJ5IHN2ZzJ0dGYgZnJvbSBGb250ZWxsbyBwcm9qZWN0LgAAaAB0AHQAcAA6AC8ALwBmAG8AbgB0AGUAbABsAG8ALgBjAG8AbQAAaHR0cDovL2ZvbnRlbGxvLmNvbQAAAgAAAAAAAAAKAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAEAAAAAQACAQIJdXNlci13YWl0AAAAAf//AAIAAQAAAAwAAAAWAAAAAgABAAMAAwABAAQAAAACAAAAAAAAAAEAAAAA1aQnCAAAAADbkinqAAAAANuSKeo=')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont1 {
  font-family: 'iconfont1' !important;
  font-size: 18px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-user-wait:before {
  content: '\e6b2';
}

.detail-footer-right button {
  font-size: 18px;
}

.refund {
  margin-left: 20px;
  padding-bottom: 2px;
  border-bottom: 1px solid blue;
}

.invoice {
  font-size: 18px;
  text-align: center;
  padding: 10px 0;
}
.invoice a {
  padding-bottom: 2px;
  border-bottom: 1px solid blue;
}
</style>
